import { render, staticRenderFns } from "./OrderChat.vue?vue&type=template&id=1322a7ec"
import script from "./OrderChat.vue?vue&type=script&lang=js"
export * from "./OrderChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports